import api from '../../../utils/api';

export const getPatientApiAdmin = (params) =>
  api.get('/admin/patients', { params });

export const getPatientByIdApiAdmin = (id) => api.get(`/admin/patients/${id}`);
